import globalStyles from '../result.module.css';
import styles from './featutes.module.css';
interface Props {
  icon: string;
  label: string;
  value: string | number;
}

const Feature = ({ icon, label, value }: Props) => {
  return (
    <div className={styles.featureDetails}>
      <div className={styles.featureIcon}>
        <img alt={label} src={`/icons/${icon}.svg`}></img>
      </div>
      <div className={styles.featureContent}>
        <h3 className={`${globalStyles.smallText}`}>
          {label}
        </h3>
        <p className={globalStyles.subTitleText}>{value}</p>
      </div>
    </div>
  );
};

export default Feature;
